import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Product } from '~shared/models';
import { APP_PRODUCT_ROUTE } from '~shared/constants';
import { environment } from '~env/environment';
import { PriceTypeService } from '~shared/modules/price-type-toggler/services/price-type.service';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-search-product-suggestion',
  templateUrl: './product-suggestion.component.html',
  styleUrls: ['./product-suggestion.component.scss']
})
export class ProductSuggestionComponent implements OnInit, OnDestroy {
  @Input() product: Product;
  @Output() productClicked = new EventEmitter<{ product: Product, priceType: PriceTypes }>();

  defaultProductImage = `${environment.cdnBaseUrl()}/images/product-catalog-placeholder.png`;
  showNetPrice: boolean;
  appStorefrontProductRoute = `/${APP_PRODUCT_ROUTE}/`;
  private destroySubject = new Subject();

  constructor(private priceTypeService: PriceTypeService) {}

  ngOnInit() {
    this.priceTypeService.priceType$.pipe(takeUntil(this.destroySubject))
      .subscribe((priceType: PriceTypes) => {
        this.showNetPrice = (priceType === PriceTypes.b2b);
      });
  }

  ngOnDestroy() {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  onProductClick(): void {
    this.productClicked.emit({
      product: this.product,
      priceType: this.showNetPrice ? PriceTypes.b2b : PriceTypes.b2c
    });
  }
}
